<template>
  <div class="modal-price-schedule-container">
    <sweet-modal ref="modal" overlay-theme="dark" @close="onClose">
      <div class="modal-title">일정/가격 설정</div>
      <template v-if="item">
        <div style="height: 60vh; overflow-y: auto">
          <admin-form-item label="적용 기간"
                          desc="적용 기간을 설정하지 않을 경우, 무한대로 설정됩니다." >
            <div class="flex" style="flex-wrap:wrap">
              <div style="align-items: center;">
                <admin-date-picker
                  type="date"
                  :data="item.start_date"
                  @setDate="date => item.start_date = date"></admin-date-picker>
              </div>
              <div class="lp-dating">&#126;</div>
              <div style="align-items: center;">
                <admin-date-picker
                  type="date"
                  :data="item.end_date"
                  @setDate="date => item.end_date = date"></admin-date-picker>
              </div>
            </div>
          </admin-form-item>

          <div class="grid-schedule" style="margin-top: 32px">
            <div v-for="(item,idx) in title" :key="`title-${idx}`" class="grid-title">{{ item }}</div>
          </div>
          <div class="divider"></div>
          <modal-item-price-schedule style="margin-bottom:0"
                                    :day="allDay"></modal-item-price-schedule>
          <div class="divider"></div>
          <modal-item-price-schedule
            v-for="(day, idx) in item.schedule" :key="`sch-${idx}`"
            :day="day"></modal-item-price-schedule>
        </div>

        <div class="btn-group-justify-end" style="padding-top:12px">
          <button class="button is-light" @click="clickCancel">취소</button>
          <button class="button is-primary" @click="clickAccept">저장</button>
        </div>
      </template>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from "sweet-modal-vue";
  import ProductPanelMixin from "../../../../mixins/ProductPanelMixin";
  import ModalItemPriceSchedule from "./ModalItemPriceSchedule";
  export default {
    name: 'ModalPriceSchedule',
    components: {
      ModalItemPriceSchedule,
      SweetModal
    },
    props: {
      prod: {
        type: Object
      },
      modifyItem: {
        type: Object
      }
    },
    mixins: [
      ProductPanelMixin
    ],
    data() {
      return {
        item: {
          start_date: null,
          end_date: null,
          schedule: []
        },
        title: ['적용일', '영업/휴무', '재고', '금액설정', '할인여부', '할인가격', '할인 후 가격'],
        days: ['월요일','화요일','수요일','목요일','금요일','토요일','일요일'],
        allDay: null,
        isModify: false
      }
    },
    created() {
      this.init();
    },
    methods: {
      open() {
        this.isModify = this.modifyItem !== undefined;
        if(this.modifyItem) {
          this.item = this.modifyItem;
          if(this.item.end_date.indexOf('9999-01-01')>-1){
            this.item.end_date = '';
          }
          this.$refs.modal.open();
        } else {
          this.item = undefined;
          setTimeout(()=>{
            this.init();
            this.$refs.modal.open();
          },100)
        }
      },
      init() {
        this.allDay = this.getSchedule(-1);
        this.item = {
          start_date: null,
          end_date: null,
          all_date: false,
          schedule: []
        };
        for(let i=0; i<7; i++) {
          this.item.schedule.push(this.getSchedule(i));
        }
      },
      getSchedule(i) {
        return this.cloneItem({
          day: i,
          possible_resv: true,
          price: 0,
          sale_price: 0,
          is_discount: false,
          discount_rate: 0.0,
          discount_price: 0,
          discount_type: -1,
          stock: 1,
          stock_type: 0
        })
      },
      onClose() {
        this.init();
      },
      clickCancel() {
        this.$refs.modal.close();
      },
      clickAccept() {
        // sale_price 설정
        this.item.schedule.forEach(i => {
          if(i.discount_type === 0) {
            i.sale_price = i.price - (i.price * (i.discount_rate / 100))
          } else if(i.discount_type === 1) {
            i.sale_price = i.price - i.discount_price;
          } else {
            i.sale_price = i.price;
          }
        });

        // 적용기간 체크
        if(!this.item.start_date || this.item.start_date === '') {
          this.item.start_date = this.moment().format('YYYY-MM-DD');
        }
        if(!this.item.end_date || this.item.end_date === '') {
          this.item.end_date = '9999-01-01';
        }

        // 모든요일 여부
        this.item.all_date = true;
        this.item.schedule.forEach(i => {
          Object.keys(this.allDay).forEach(key => {
            if(['day','sale_price'].indexOf(key) === -1) {
              if(i[key] !== this.allDay[key]) {
                this.item.all_date = false;
              }
            }
          });
        })

        if(this.isModify) {
          this.$axios.patch(this.getUrl(`booking/product/${this.prod.id}/schedule_price/${this.item.id}`), this.item).then(res => {
            this.$emit('onModify', this.cloneItem(this.item));
            this.$emit('updatePrice', res.data.price);
            this.$refs.modal.close();
            this.toastStatus('일정/가격이 저장되었습니다.');
          });
        } else {
          this.$store.commit('setLoading', true);
          this.$axios.post(this.getUrl(`booking/product/${this.prod.id}/schedule_price`), this.item).then(res => {
            this.$store.commit('setLoading', false);
            if(res.status === 200) {
              this.item.id = res.data.id;
              this.$emit('onAdd', this.cloneItem(this.item));
              this.$emit('updatePrice', res.data.price);
              this.$refs.modal.close();
              this.toastStatus('일정/가격이 저장되었습니다.');
            }
          }).catch(()=>{
            this.$store.commit('setLoading', false);
            this.toastStatus('저장 중 오류가 발생하였습니다.');
          });
        }
      }
    },
    watch: {
      allDay: {
        handler(n) {
          Object.keys(n).forEach(key => {
            if(key !== 'day') {
              this.item.schedule.forEach(s => {
                s[key] = n[key];
              });
            }
          });
        },
        deep: true
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .modal-price-schedule-container
    color #363636

  .modal-title
    font-size 20px
    font-weight 700
    margin-bottom 36px

  .grid-schedule
    display grid
    grid-template-columns 60px 80px 80px 200px 100px 150px 120px
    grid-gap 20px
    align-items center

  .divider
    width 100%
    height 1px
    background-color #eeeeee
    margin 12px 0

  .grid-title
    font-size 14px

</style>
<style lang="stylus">
  .modal-price-schedule-container
    .sweet-modal.is-alert
      width 1000px
      max-height 90vh
    .sweet-modal.is-alert .sweet-content
      padding 28px 32px 16px 32px
</style>
